import { useState, useContext } from "react";
import "./accountSecurity.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import usersRequest from "../../../request/usersRequest";
import BannerMessage from "../../common/bannerMessage/bannerMessage";

const AccountSecurity = () => {
	const { language, userData } = useContext(CombinedContext);

	const userEmail =
		userData?.user?.email ||
		userData?.email ||
		"";

	const [email, setEmail] = useState(userEmail);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [toast, setToast] = useState("");

	async function handleResetPassword(e) {
		e.preventDefault();
		if (!email) return;

		try {
			setLoading(true);
			setToast("");

			await usersRequest.forgotPassword(email);
			setSuccess(true);
		} catch (err) {
			console.error(err);
			setToast(
				translations[language].forgotPassword.toast.error
			);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="sf-security-page">
			<h2 className="sf-security-title">
				{translations[language].account.security?.title || "Security"}
			</h2>

			{/* EMAIL INFO BLOCK */}
			<div className="sf-security-section">
				<h3 className="sf-security-section-title">
					{translations[language].account.security?.emailTitle || "Email"}
				</h3>

				<div className="sf-security-email-display">
					{email || "—"}
				</div>
			</div>

			{/* RESET PASSWORD */}
			<div className="sf-security-section">
				<h3 className="sf-security-section-title">
					{translations[language].account.security?.passwordTitle ||
						"Reset Password"}
				</h3>

				{success ? (
					<p className="sf-security-success">
						{translations[language].forgotPassword.success}
					</p>
				) : (
					<form
						className="sf-security-form"
						onSubmit={handleResetPassword}
					>
						<p className="sf-security-sub">
							{translations[language].forgotPassword.subtitle}
						</p>

						<div className="sf-security-row">
							<input
								type="email"
								className="sf-security-input"
								value={email}
								onChange={(e) =>
									setEmail(e.target.value)
								}
								required
							/>

							<button
								type="submit"
								className="sf-security-button"
								disabled={loading}
							>
								{loading
									? translations[language].forgotPassword
											.sending
									: translations[language].forgotPassword
											.send}
							</button>
						</div>
					</form>
				)}
			</div>

			{toast && <BannerMessage text={toast} />}
		</div>
	);
};

export default AccountSecurity;
